var styles = {"root":"ReferralBanner-module_root__3t8aG","imageContainer":"ReferralBanner-module_imageContainer__3L5SJ","image":"ReferralBanner-module_image__2CGMx","content":"ReferralBanner-module_content__e5hOW","text":"ReferralBanner-module_text__18oFh","actions":"ReferralBanner-module_actions__2nWI0"};

export { styles as default };
//# sourceMappingURL=ReferralBanner.module.css.js.map
